// extracted by mini-css-extract-plugin
export default {"shape":"RealtimeActiveUsers_shape__wmET7"};